import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  
  baseURL: 'http://192.168.0.19',
  isLoading: false,
  direction: 'forward',
  isTabbaerShow:true,
}
export default new Vuex.Store({
  state,
  mutations: {
    UPDATE_LOADING (state, status) {
      state.isLoading = status
    },
    UPDATE_DIRECTION (state, direction) {
      state.direction = direction
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js